import React, { createContext, useContext } from "react";
import { useParams } from "react-router-dom";
import { useFetch } from "@/hooks/useFetch";
import { fetchOpeningMeta } from "./api";

const OpeningContext = createContext(null);

export const OpeningProvider = ({ children }) => {
  const { openingId } = useParams();

  const {
    data: opening,
    isLoading: isOpeningLoading,
    isError: isOpeningError,
  } = useFetch({
    queryKey: ["opening", openingId],
    queryFn: () => fetchOpeningMeta({ openingId }),
  });


  return (
    <OpeningContext.Provider
      value={{
        opening,
        ...opening,
        isOpeningLoading,
        isOpeningError,
        openingId,
        isLoading: isOpeningLoading,
      }}
    >
      {children}
    </OpeningContext.Provider>
  );
};

export const useOpening = () => {
  const context = useContext(OpeningContext);
  if (!context) {
    throw new Error("useOpeningContext must be used within a OpeningProvider");
  }
  return context;
};
